<template>
  <div v-loading="loading">
    <div style="display: flex; align-items: flex-end">
      <div style="display: flex; justify-items: center">
        <label for="upFile" class="up-button btn-left">
          <span>上传文件</span>
          <input
            type="file"
            id="upFile"
            class="up-file"
            multiple
            @change="handleFileSelect"
          />
        </label>
        <label for="upFileDdirectory" class="up-button btn-right">
          <span>上传文件夹</span>
          <input
            type="file"
            id="upFileDdirectory"
            class="up-file"
            webkitdirectory
            directory
            multiple
            @change="handleFileSelect"
          />
        </label>
      </div>
      <div style="font-size: 12px; margin-left: 6px">* 同名文件将会被覆盖</div>
    </div>
    <div class="dovDropzone">
      <div v-for="item in fileList">
        <span class="el-icon-document"></span>
        {{ item.name }}
        <span class="el-icon-delete del" @click="deleteFile(item)"></span>
      </div>
      <div id="upload"></div>
    </div>

    <div>
      <el-button type="primary" :Loading="loading" @click="done"
        >确定</el-button
      >
      <el-button @click="cancel">取消</el-button>
    </div>

    <!-- <el-dialog :title="$t('message.tips.upLoad')" :visible.sync="upLoadDialog" width="30%" height="50%"
      :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
       <el-progress :text-inside="true" :stroke-width="16" :percentage="upLoadProgress" status="success"></el-progress>
     </el-dialog> -->
  </div>
</template>

<script>
import axios from 'axios'
// import { gridOptions } from "../../../utils/xGrid_Config";
import { Base64 } from 'js-base64'
import BottomTips from '@/components/bottomTips.vue'
import { CHANGE_FOR_MEDLINKET } from '@/utils/constants.js'

export default {
  data() {
    return {
      // dialogClosedUploadId: "",
      // obsKey: "",

      // selectRecords: [],
      // totalRecords: "",
      // gridOptions: { ...gridOptions },
      // editShow: false,

      // cascaderShow: false,
      // cascaderValue: [],
      // cascaderList: [],
      // cascaderProps: {},
      loading: false,

      upLoadProgress: 0,
      upLoadDialog: false, //上传

      fileList: [],
      changeInfo: {},

      // resURL:''
    }
  },
  props: {
    // changeInfo: Object
  },
  // watch: {
  //   changeInfo(val) {
  //   }
  // },

  components: { BottomTips },
  methods: {
    deleteFile(item) {
      this.fileList = this.fileList.filter((i) => i.order !== item.order)
    },
    done() {
      this.loading = true
      this.setChangeRelease()
        .then((res) => {
          const { object } = res.data
          return this.setSaveTable(object)
        })
        .then((res) => {
          // return
          this.fileList.map((i) => {
            this.upLoad(i)
          })
          // this.$emit('getStatusChange', this.changeInfo)
        })
        .finally((_) => {
          this.loading = false
        })
      // this.$emit('getStatusChange', this.changeInfo)
    },
    cancel() {
      this.$emit('dialogClose')
    },
    setChangeRelease() {
      const obj = { ...CHANGE_FOR_MEDLINKET }
      return axios.post(`/pmdm/changes/saveChangeP1P2P3`, obj)
    },
    setSaveTable(object) {
      const { id, classId, subclassId: subClassId } = object
      this.changeInfo = {
        changeId: id,
        changeClassId: classId,
        changeSubClassId: subClassId,
      }
      const obj = {
        tableId: 5,
        changeObjId: {
          id,
          classId,
          subClassId,
          version: this.version,
        },
        insertAffectedItem: [
          { changeId: id, item: this.$store.state.objectId.id, 1005007: 248 },
        ],
        inheritAttachment: false,
      }
      return axios.post('/pmdm/changes/saveTable', obj)
    },
    handlefile(file) {
      let num = 1
      if (file.isFile) {
        // 是文件执行上传操作
        //file.file() 方法用于读取文件内容
        file.file((f) => {
          f.order = num + f.lastModified
          this.fileList.push(f)
          num++
          // f才是最终的文件
          // this.upLoad(f);
          // const text = document.createTextNode(f.name + '—');
          // dropzone.appendChild(text);
          return
        })
      } else {
        const dirReader = file.createReader()
        dirReader.readEntries((entries) => {
          for (let i = 0; i < entries.length; i++) {
            this.handlefile(entries[i])
          }
        })
      }
    },

    handleFileSelect(event) {
      const { files } = event.target

      let num = 1
      for (const key in files) {
        if (Object.prototype.hasOwnProperty.call(files, key)) {
          const element = files[key]
          element.order = num + element.lastModified
          // this.upLoad(files[key]);
          this.fileList.push(files[key])
          num++
        }
      }
      // event.preventDefault();
    },

    handleClose(done) {
      this.$confirm(this.$t('message.tips.closeUpLoad'))
        .then((_) => {
          this.upLoadDialog = false
        })
        .catch((_) => {})
    },

    upLoad(file) {
      const fd = new FormData()
      const objInfo = {
        ...this.$store.state.objectId,
        ...this.changeInfo,
      }
      const { classId, subClassId, id, changeId } = objInfo,
        tenantName = window.sessionStorage.getItem('tenantName')
      const path = [
        tenantName,
        classId,
        subClassId,
        id,
        changeId,
        file.name,
      ].join('/')
      const obj = {
        ...objInfo,
        path,
        fileSize: file.size,
        fileName: file.name,
      }
      for (const key in obj) {
        fd.append(key, obj[key])
      }
      axios.post('/swift-file/files/checkFileNameAndRev', fd).then((res) => {
        const { code, url, message, fileName } = res.data.object
        if (code == 501) {
          this.$confirm(
            this.$t('message.confirm.overwrite'),
            fileName,
            this.$t('message.tips.tip'),
            {
              confirmButtonText: this.$t('message.button.affirm'),
              cancelButtonText: this.$t('message.button.cancel'),
              type: 'warning',
            }
          )
            .then(() => {
              this.updateFile(file, fd, url)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('message.tips.cancel'),
              })
            })
        } else if (code == 200) {
          this.updateFile(file, fd, url)
        } else {
          this.$message.error(message)
          return false
        }
      })
    },

    updateFile(file, fd, url) {
      // if (file.size == 0) {
      //   this.upLoadDialog = false; //当附件大小为0KB时，不显示进度条
      // } else {
      //   this.upLoadDialog = true; //展示进度条
      // }
      var reopt = {
        method: 'PUT',
        url: url,
        withCredentials: false,
        headers: { 'Content-Type': 'application/octet-stream' },
        validateStatus: function (status) {
          return status >= 200
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            var complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0
            for (let index = 0; index < 81; index++) {
              this.upLoadProgress = index
            }
            if (complete >= 100) {
              this.upLoadDialog = false
              this.upLoadProgress = 0 // 重新置0
            }
          }
        },
        maxRedirects: 0,
        data: file,
      }

      axios
        .request(reopt)
        .then((res) => {
          if ((res.status = 200 && res.data == '')) {
            return axios.post('/swift-file/files/uploadFileMetadata', fd)
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message:
                this.$t('message.title.attachment') +
                file.name +
                this.$t('message.success.upLoad'),
              type: 'success',
            })
            this.fileList.find((i) => i.order === file.order).completed = true
            const fileCompleted = this.fileList.every((i) => !!i?.completed)
            fileCompleted && this.$emit('getStatusChange', this.changeInfo)
          }
        })
        .catch(function (err) {
          this.$message.error(this.$t('message.error.add'))
        })
    },

    getChangeInfo() {
      console.log(this.changeInfo)
    },
  },

  created() {
    this.getChangeInfo()
  },
  mounted() {
    // this.setDrag();
    const dropzone = document.querySelector('.dovDropzone')
    dropzone.addEventListener('dragover', (event) => {
      event.target.classList.add('fileshover')
      event.preventDefault() //阻止默认行为，允许放置
    })

    dropzone.addEventListener('drop', (event) => {
      const dataTransferItemList = event.dataTransfer.items
      for (const dataTransferItem of dataTransferItemList) {
        const file = dataTransferItem.webkitGetAsEntry()
        this.handlefile(file)
      }
      event.preventDefault() //阻止浏览器默认行为，不会自动打开文件管理页面
    })
  },
}
</script>

<style scoped>
.del {
  margin-left: 6px;
  cursor: pointer;

  &:hover {
    color: #4b92ff;
  }
}

.dovDropzone {
  /* background: silver; */
  width: 100%;
  height: 260px;
  border: #4b92ff 1px dashed;
  margin: 8px 0;
  font-size: 12px;
  padding: 10px 15px;
  box-sizing: border-box;
}

.dropzone .filehover {
  background-color: cadetblue;
}

.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.up-button {
  /* width: 120px; */
  /* height: 32px;
  line-height: 32px; */
  color: #fff;
  font-size: 12px;
  background-color: #4b92ff;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 3px;
}

.btn-left {
  /* border-radius: 3px 0 0 3px; */
}

.btn-right {
  /* border-radius: 0 3px 3px 0; */
  margin-left: 10px;
}

.up-file {
  border: none;
  display: none;
}

.input-file {
  display: none;
}

.drag-upload-box {
  /* width: 200px;
  height: 130px; */
  width: 100%;
  height: 600px;
}

.available {
  position: relative;
  /* 必须设置相对定位 */
}

.drag-upload-box.available::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(64, 158, 255, 0.3);
  /* rgba(87, 98, 227, 0.5); */
  /* 设置蒙版颜色和透明度 */
  z-index: 1;
  /* 确保蒙版在元素上方 */
}

.drag-upload-box.available > * {
  /* 防止拖拽到 子元素导致触发 dragleave*/
  pointer-events: none;
}

.drag-upload-box.guide > * {
  pointer-events: none;
}
</style>
